import {Component, h} from '@stencil/core';
import {t} from "../../../redux/utils";

@Component({
    tag: 'rtr-button-unavailable',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RtrButtonUnavailable {
    get notAvailableTitle() {
        return t('articleBooking.notAvailableText')
    }
    get notAvailableText() {
        return t('articleBooking.notAvailableTitle')
    }

    render() {
        return (
            <div class="RBUContainer">
                <svg width="22" height="20" viewBox="0 0 22 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.26795 2C10.0377 0.666667 11.9623 0.666667 12.7321 2L20.5263 15.5C21.2961 16.8333 20.3338 18.5 18.7942 18.5H3.20577C1.66617 18.5 0.70392 16.8333 1.47372 15.5L9.26795 2Z"
                        stroke-width="2"/>
                </svg>

                <div class="RBUInner">
                    <span class="Title">{this.notAvailableTitle}</span>
                    <span>{this.notAvailableText}</span>
                </div>
            </div>

        )
    }
}
